import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center px-8 py-16 gap-4',
        className
      )}
    >
      <div
        className="rounded-2xl p-4"
        style={{ background: 'var(--color-primary-muted)' }}
      >
        <Icon size={32} style={{ color: 'var(--color-primary)' }} />
      </div>
      <div className="space-y-1">
        <h3
          className="text-base font-semibold"
          style={{ color: 'var(--color-text)' }}
        >
          {title}
        </h3>
        {description && (
          <p
            className="text-sm"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}
